import React from "react";
import Alerter from "./../components/alerter";
import OuterHeader from "./../ui/outer-header";
import EmailUs from "./../ui/contact/email-us";
import SocialUs from "./../ui/contact/social-us";
import VisitUs from "./../ui/contact/visit-us";
import Footer from "./../components/footer"
import useAuth from "./../context/auth";
import { gradient_primary } from "../assets/data/colors";

// the contact page
const Contact = () => {
    const { auth } = useAuth();

    return (
        <div className="min-h-screen">
            <Alerter />
            {!auth && <OuterHeader />}

            <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
                <div className="text-center mb-10 sm:mb-16">
                    <span style={{background: gradient_primary}} className="inline-block text-xs font-semibold tracking-[2.5px] uppercase text-white bg-[#E6F1FB] dark:bg-[#0C447C]/30 dark:text-[#85B7EB] px-4 py-1.5 rounded-full mb-5">
                        We're here for you
                    </span>
                    <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-3 sm:mb-4 leading-tight dark:text-white">Get in Touch</h1>
                </div>

                <div className="bg-white dark:bg-[#0d1117] border border-gray-100 dark:border-gray-800 rounded-2xl p-8 mb-5 contact-card">
                    <div className="section-divider">
                        <div className="section-num">01</div>
                        <div className="section-divider-line" />
                    </div>
                    <EmailUs />
                </div>

                <div className="bg-white dark:bg-[#0d1117] border border-gray-100 dark:border-gray-800 rounded-2xl p-8 mb-5 contact-card">
                    <div className="section-divider">
                        <div className="section-num">02</div>
                        <div className="section-divider-line" />
                    </div>
                    <SocialUs />
                </div>

                <div className="bg-white dark:bg-[#0d1117] border border-gray-100 dark:border-gray-800 rounded-2xl p-8 contact-card">
                    <div className="section-divider">
                        <div className="section-num">03</div>
                        <div className="section-divider-line" />
                    </div>
                    <VisitUs />
                </div>
            </div>

            <Footer />
        </div>
    );
};
export default Contact;